export const jobEducationLevelsSk = {
  jobEducationLevels: {
    'no_education_required': 'Bez požiadaviek',
    'primary_education': 'Základné vzdelanie',
    'secondary_education': 'Stredné vzdelanie',
    'complete_secondary_education': 'Úplné stredné vzdelanie (maturita)',
    'bachelors_degree': 'Vysokoškolské vzdelanie prvého stupňa (Bc.)',
    'masters_degree': 'Vysokoškolské vzdelanie druhého stupňa (Mgr./Ing.)',
    'doctoral_degree': 'Vysokoškolské vzdelanie tretieho stupňa (PhD.)'
  }
};
